import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// Siblings.
import './styles.css';

//------------------------------------------------------------------------------

const Row = ({ children, className, gutter }) => {
  const classNameRoot = classNames('Row', className);
  const margin = `-${gutter / 2}rem`;
  const styleRoot = { marginLeft: margin, marginRight: margin };
  return (
    <div className={classNameRoot} style={styleRoot}>
      {children}
    </div>
  );
};

Row.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  gutter: PropTypes.number,
};

Row.defaultProps = {
  className: null,
  gutter: 1,
};

export default Row;



// WEBPACK FOOTER //
// ./src/components/Grid/Row/index.js